import styled from 'styled-components';
import backgroundImage from '../images/marketing-pro-hero-bg.jpg';
import backgroundStripes from '../images/marketing-pro-hero-stripes.png';

const Container = styled.div`
  background-image: url(${backgroundImage});
  position: relative;
  background-position: top center;
  background-repeat: repeat-x;
  background-color: var(--dark-gray-color);

  .marketing-pro-hero--inner-container {
    background: url(${backgroundStripes});
    background-size: 1100px;
    padding: 128px 0px 100px 0px;
    max-width: 1296px;
    margin: 0px auto;
    background-position: top center;
    background-repeat: no-repeat;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 1600px) {
      padding: 128px 20px 100px 20px;
      background-position-x: 225px;
      background-size: 1000px;
    }

    @media (max-width: 1200px) {
      background-position-x: 200px;
      background-size: 900px;
    }

    @media (max-width: 992px) {
      padding: 128px 20px 50px 20px;
      flex-direction: column;
      background-position-x: 100px;
      background-size: 900px;
    }

    @media (max-width: 768px) {
      background-position-x: 90px;
      background-position-y: 60px;
      background-size: 650px;
    }

    @media (max-width: 576px) {
      padding-top: 176px;
      background-position-x: 55px;
      background-size: cover;
    }
  }

  .marketing-pro-hero--sub-title {
    font-size: 25px;
    margin: 1em 0px 80px;

    @media (max-width: 576px) {
      font-size: 20px;
    }
  }

  .marketing-pro-hero--copy-video-bottom {
    text-align: center;
    max-width: 800px;
    margin: 0 auto;
  }

  .marketing-pro-hero--copy-video-right {
    text-align: left;
    width: calc(50% - 40px);

    form {
      justify-content: start;
    }

    @media (max-width: 992px) {
      text-align: center;
      width: 100%;
    }
  }

  .marketing-pro-hero--video-right {
    width: calc(50% - 40px);
    @media (max-width: 992px) {
      text-align: center;
      width: 100%;
    }
  }

  .marketing-pro-hero--image {
    position: absolute;
    right: 0;
    bottom: 0;
    /* display: none; */
  }

  span {
    text-decoration: underline;
    text-decoration-color: var(--secondary-color);
  }
`;

export { Container };
